AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Models", "HallOfFame");

AoPS.Alcumus.Models.HallOfFame = (function () {
	// Dependencies
	var LoadUtils = AoPS.LoadUtils;
	var AlcMBase = AoPS.Alcumus.Models.Base;

	return AlcMBase.BaseModel.extend({
		defaults: {
			// Each is an object with friends and all keys
			recent_levels: null,
			recent_passed: null,
			recent_mastered: null,
			recent_quests: null,
			day_problem_streak: null,
			week_overall_xp: null,
			week_algebra_xp: null,
			week_counting_xp: null,
			week_geometry_xp: null,
			week_number_theory_xp: null,
			week_prealgebra_xp: null,
			week_interm_algebra_xp: null,
			week_precalc_xp: null,
			week_first_xp: null,
			week_hard_xp: null,
			week_second_xp: null,
			week_streak_xp: null,
			scores_all: null,
		},
		/** Additional attributes:
			master: Master model owning this one; guaranteed to be set
		*/

		heading_table: {
			recent_levels: "Recent Levels Gained",
			recent_passed: "Recent Topics Passed",
			recent_mastered: "Recent Topics Mastered",
			recent_quests: "Recent Quests Completed",
			day_problem_streak: "Highest Problem Streak Today",
			week_overall_xp: "Most Overall XP This Week",
			week_algebra_xp: "Most Algebra XP This Week",
			week_counting_xp: "Most Counting XP This Week",
			week_geometry_xp: "Most Geometry XP This Week",
			week_number_theory_xp: "Most Number Theory XP This Week",
			week_prealgebra_xp: "Most Prealgebra XP This Week",
			week_interm_algebra_xp: "Most Intermediate Algebra XP This Week",
			week_precalc_xp: "Most Precalculus XP This Week",
			week_first_xp: "Most Accuracy XP This Week",
			week_hard_xp: "Most Power XP This Week",
			week_second_xp: "Most Resilience XP This Week",
			week_streak_xp: "Most Stamina XP This Week",
			scores_all: "Highest Alcumus Rating",
		},

		initialize: function () {
			this.setLoader(
				new LoadUtils.LoadManager({
					loadHandler: this.loadHallOfFame,
					context: this,
				})
			);
		},

		loadHallOfFame: function (callback) {
			var user_me = this.get("master").getUser("me");
			AlcMBase.ajax.run(
				"load_hall_of_fame",
				{
					user_id: user_me.id,
					friend_lists: JSON.stringify(this.get("loaded_friend_lists") || []),
				},
				_.bind(function (ok, data) {
					if (!ok || !data.response) {
						if (callback) {
							return callback(ok, data);
						}
						return;
					}
					this.unpack(data.response.hall_of_fame);
					user_me.unpack(data.response.user);
					this.trigger("loaded");
					setTimeout(AoPS.fixSidebarOnce, 1000);

					// Reload hall of fame periodically
					setTimeout(
						_.bind(function () {
							this.loadHallOfFame(function () {});
						}, this),
						900000
					);
				}, this)
			);
		},

		loadHallOfFameFriendList: function (list_name) {
			var user_me = this.get("master").getUser("me");
			AlcMBase.ajax.run(
				"load_hall_of_fame_friend_list",
				{user_id: user_me.id, friend_list: list_name},
				_.bind(function (ok, data) {
					if (ok) {
						this.set(
							"loaded_friend_lists",
							_.uniq(this.get("loaded_friend_lists") || []).concat([list_name])
						);
						this.get(list_name).friends = data.response.friends || [];
					}
					this.trigger("loaded");
				}, this)
			);
		},

		unpack: function (data) {
			if (!data) {
				return;
			}

			this.setFields(data);

			this.markAsLoaded(true);
		},

		getKeys: function () {
			return _.keys(this.defaults);
		},

		getTitle: function (key) {
			return this.heading_table[key] || "Unknown Category";
		},

		// Returns a function that makes the displayed entry in the hall of fame
		// given an object with data appropriate to the list.
		// Username etc. is not included; that's in the template itself.
		getEntryWriter: function (key) {
			switch (key) {
				case "recent_levels":
					return function (obj) {
						return "- Level " + obj.level + " - " + obj.name;
					};
				case "recent_passed":
					return function (obj) {
						return "passed " + obj.topic_name + ".";
					};
				case "recent_mastered":
					return function (obj) {
						return "mastered " + obj.topic_name + ".";
					};
				case "recent_quests":
					return function (obj) {
						return "completed " + obj.quest_name + ".";
					};
				case "day_problem_streak":
					return function (obj) {
						return "got a streak of " + obj.streak + " problems.";
					};
				case "week_overall_xp":
				case "week_algebra_xp":
				case "week_counting_xp":
				case "week_geometry_xp":
				case "week_number_theory_xp":
				case "week_prealgebra_xp":
				case "week_interm_algebra_xp":
				case "week_precalc_xp":
				case "week_first_xp":
				case "week_hard_xp":
				case "week_second_xp":
				case "week_streak_xp":
					return function (obj) {
						return "earned " + obj.amount + " XP this week";
					};
				case "scores_all":
					return function (obj) {
						return "(" + Math.ceil(obj.score * 100) / 100 + ")";
					};
			}
		},
	});
})();
